import {
  GET_TAX_ANNOTATION,
  GET_TAX_ANNOTATION_ERROR,
  GET_TAX_ANNOTATION_SUCCESS
} from './TaxAnnotationsSection.actions'

const taxAnnotacionsState = {
  error: undefined,
  loading: true,
  annotations: []
}

/**
 * Tax Annotation Section reducer.
 */
const taxAnnotationsReducer = (state = taxAnnotacionsState, { payload, type }) => {
  switch (type) {
    case GET_TAX_ANNOTATION:
      return { ...state, loading: true }
    case GET_TAX_ANNOTATION_SUCCESS: {
      return {
        ...state,
        annotations: payload.annotations,
        loading: false
      }
    }
    case GET_TAX_ANNOTATION_ERROR:
      return { ...state, error: payload.error, loading: false }
    default:
      return state
  }
}

export default taxAnnotationsReducer
